export default "__VITE_ASSET__BNpScMTA__"